import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import {
  isDeliveryOrderArrivedOrder,
  isDeliveryOrderAssign,
  isDeliveryOrderCreate,
  isDeliveryOrderOutForDelivery,
  isDeliveryOrderPickedUp,
  isDeliveryOrderStoreArrival,
} from 'common/utilities/orderStatusUtils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

export const getDeliveryDriver = () => {
  return (
    <div className='col-lg-5 col-12'>
      <span className='head-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.DELIVERY_DRIVER)}</span>
    </div>
  );
};

export const getContactNameJSX = orderDetails => {
  const { riderName } = orderDetails?.deliveryDetails;
  return (
    <div className='col-lg-7 col-6 contact-name-text'>
      <span className='rider-name'>
        <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.CONTACT)}</span>{' '}
        <span>
          <strong>{riderName}</strong>
        </span>
      </span>
    </div>
  );
};

export const getRaiderMessage = orderDetails => {
  const { riderName } = orderDetails?.deliveryDetails;
  const riderNamespan = <span className='rider-name'>{riderName} </span>;

  if (isDeliveryOrderCreate(orderDetails)) {
    return orderDetails?.sameOrderStatusMaintainLast30Mins
      ? translateWithI18Next(TRANSLATE_MAPPING_KEY?.ITS_BUSY_AND_ITS_TAKING_A_WHILE_TO_FIND_A_DRIVER)
      : `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.FINDING_DRIVER)}...`;
  } else if (isDeliveryOrderAssign(orderDetails)) {
    return (
      <span>
        {riderNamespan} {translateWithI18Next(TRANSLATE_MAPPING_KEY?.HAS_ACCEPTED_TO_DELIVER_YOUR_ORDER)}
      </span>
    );
  } else if (isDeliveryOrderStoreArrival(orderDetails)) {
    return (
      <span>
        {riderNamespan} {translateWithI18Next(TRANSLATE_MAPPING_KEY?.IS_ON_HIS_WAY_TO_THE_RESTAURANT)}
      </span>
    );
  } else if (isDeliveryOrderPickedUp(orderDetails)) {
    return (
      <span>
        {riderNamespan} {translateWithI18Next(TRANSLATE_MAPPING_KEY?.IS_ON_THE_WAY)}
      </span>
    );
  } else if (isDeliveryOrderOutForDelivery(orderDetails)) {
    return (
      <span>
        {riderNamespan} {translateWithI18Next(TRANSLATE_MAPPING_KEY?.IS_ON_THE_WAY)}
      </span>
    );
  } else if (isDeliveryOrderArrivedOrder(orderDetails)) {
    return (
      <span>
        {riderNamespan} {translateWithI18Next(TRANSLATE_MAPPING_KEY?.IS_ALMOST_THERE)}
      </span>
    );
  }
  return '';
};

export const getRaiderMessageJSX = orderDetails => {
  return (
    <div className='col-lg-7 col-12 left-sec'>
      <span className=''>{getRaiderMessage(orderDetails)}</span>
    </div>
  );
};

export const getRaiderContactJSX = orderDetails => {
  const { riderPhone, riderPhoneForCustomer } = orderDetails?.deliveryDetails;
  const { CallIcon, MessageWhite } = IMAGE_PATH;
  return (
    <div className='col-5 row rgt-sec'>
      <div className='contact-text'>
        <img src={MessageWhite} alt={translateWithI18Next(TRANSLATE_MAPPING_KEY?.TEXT)} />
        <a href={`sms:${riderPhone || riderPhoneForCustomer}`} className='anchorTags'>
          <span className='contact-text text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.TEXT)}</span>
        </a>
      </div>
      <div className='contact-call'>
        <img src={CallIcon} alt={translateWithI18Next(TRANSLATE_MAPPING_KEY?.CALL)} />
        <a href={`tel:${riderPhone || riderPhoneForCustomer}`} className='anchorTags'>
          <span className='contact-text call'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.CALL)}</span>
        </a>
      </div>
    </div>
  );
};
